import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createColor,
  fetchAllColors,
  updateColor,
  fetchOneColor,
  deleteColor,
} from "services/color";

// Fetch all colors with optional filtering
export const useAllColors = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["colors", filters],
    queryFn: () => fetchAllColors(filters),
    enabled,
  });
};

// Fetch single color by ID
export const useOneColor = (id, enabled = true) => {
  return useQuery({
    queryKey: ["color", id],
    queryFn: () => fetchOneColor(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new color
export const useCreateColor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createColor(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["colors"] });
    },
  });
};

// Update existing color
export const useUpdateColor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateColor(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["colors"] });
      queryClient.invalidateQueries({ queryKey: ["color", variables.id] });
    },
  });
};

// Delete color
export const useDeleteColor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteColor(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["colors"] });
      queryClient.invalidateQueries({ queryKey: ["color", id] });
    },
  });
};
